module.exports = __webpack_public_path__ + "img/refundable.79495a2f.svg";